import Vue from 'vue';
import VueRouter from 'vue-router';
import { guardBeforeEach } from './guardBeforeEach';

import { routes } from './routes';

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach(guardBeforeEach);
